export enum Language {
    NO = 'no',
    SV = 'sv',
    EN = 'en',
}

export function isLang(id: string): id is Language {
    return id.toUpperCase() in Language;
}
